import { ReactNode, isValidElement } from 'react'

export function isReactNode(node: any): node is ReactNode {
  return (
    typeof node === 'string'
    || typeof node === 'number'
    || typeof node === 'boolean'
    || node === null
    || node === undefined
    || (Array.isArray(node) && node.every(isReactNode))
    || isValidElement(node)
  )
}
